import React, { useEffect, useState, useRef } from "react";

import "react-toastify/dist/ReactToastify.css";

var Modal = require("react-bootstrap-modal");

export const Amenities = ({
  onNext,
  onPrev,
  formData,
  setFormData,
  className,
  amenityList,
  save,
  updating
}) => {
  const [amenities, setAminities] = useState(formData["amenities"] || []);

  const valueRef = useRef(formData);

  const elementRef = useRef(null);

  
  useEffect(() => {
    valueRef.current = {...formData}
  }, [formData])
  
  useEffect(() => {
    const element = elementRef.current;
    if (!element) return;
    
    const observer = new MutationObserver(() => {
      if (element.classList.contains('tw-hidden')) {
        handleComponentDisappear();
      }
    });
    
    observer.observe(element, {
      attributes: true,
      attributeFilter: ['class']
    });
    
    return () => observer.disconnect();
  }, []);

  const handleComponentDisappear = () => {
    setFormData(valueRef.current);
  };

  const handleStep = (val) => {
    const ind = amenities.indexOf(val);
    const updatedAminities = [...amenities];
    if (ind > -1) {
      updatedAminities.splice(ind, 1);
    } else {
      updatedAminities.push(val);
    }
    setAminities(updatedAminities);
    valueRef.current = { ...formData, amenities: updatedAminities }
  };

  const handleNextStep = () => {
    valueRef.current = { ...formData, amenities: [...amenities] }
    setFormData({ ...formData, amenities: [...amenities] });
    if (amenities.length) {
      setTimeout(() => {
        save({ amenities });
        onNext();
      }, 0); 
    }
  };
  return (
    <div className={className}  ref={elementRef}>
      <div className="tw-min-h-[60vh]">
        <h4 className="mb-2 tw-flex tw-justify-start tw-items-center">
          <span className="tw-bg-[#23426e] tw-mr-2 tw-flex tw-justify-center tw-items-center  tw-h-10 tw-w-10 tw-text-white  tw-rounded-full">
            5
          </span>
          Amenities
        </h4>
        <div className="my-3 row ">
          {amenityList.map((data) => (
            <div
              key={data.id}
              className="form-check form-check-inline col-lg-3"
            >
              <label className="form-check-label">
                <input
                  onChange={(e) => handleStep(e.target.value)}
                  checked={amenities.includes(data.id)}
                  type="checkbox"
                  className="form-check-input tw-h-5 tw-w-5"
                  value={data.id}
                />
                {data.name}
              </label>
            </div>
          ))}
        </div>
      </div>
      <div>
        <button
          onClick={onPrev}
          type="button"
          className="btn btn-secondary mx-2 tw-mb-2"
        >
          Prev
        </button>

        <button
          disabled={updating}
          onClick={handleNextStep}
          className="btn btn-secondary tw-mb-2"
        >
          {updating ? "Updating ..." : "Save & Next"}
        </button>
      </div>
    </div>
  );
};

export const validateAmenities = (formData) => {

  const {amenities} = formData
  const errors = [];

  if (!amenities) {
    errors.push({
      error: "Amenities field is required",
      errorType: 'amenities'
    })
    return { errors, isValid: false };
  }


  if (amenities.length === 0) {
    errors.push({
      error: "No amenities selected. Consider adding at least one amenity",
      errorType: 'amenities'
    })
    return { errors, isValid: false };
  }

  return {
    errors,
    isValid: Object.keys(errors).length === 0,
  };
};
